import { partsToText } from './areas';
import { SITE_ORIGIN, SOCIAL_SAME_AS } from './site';
import { SERVICES_PAGE } from './homeSeo';

function pageUrl(path) {
  return `${SITE_ORIGIN}${path === '/' ? '/' : path}`;
}

export function faqPageNode(faqs) {
  return {
    '@type': 'FAQPage',
    mainEntity: (faqs || []).map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: partsToText(faq.a),
      },
    })),
  };
}

export function jobJsonLd(job) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Service',
        name: job.h1,
        serviceType: job.serviceType,
        description: job.description,
        url: pageUrl(job.path),
        areaServed: {
          '@type': 'City',
          name: 'Swansea',
          containedInPlace: {
            '@type': 'AdministrativeArea',
            name: 'City and County of Swansea',
          },
        },
        provider: {
          '@type': 'Organization',
          name: 'The WasteGame',
          url: SITE_ORIGIN,
          sameAs: SOCIAL_SAME_AS,
          email: 'info@thewastegame.co.uk',
        },
      },
      faqPageNode(job.faqs),
    ],
  };
}

export function guideJsonLd(guide) {
  const url = pageUrl(guide.path);
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: guide.h1,
    description: guide.description,
    url,
    datePublished: guide.datePublished,
    dateModified: guide.datePublished,
    author: {
      '@type': 'Organization',
      name: 'The WasteGame',
      url: SITE_ORIGIN,
      sameAs: SOCIAL_SAME_AS,
    },
    publisher: {
      '@type': 'Organization',
      name: 'The WasteGame',
      url: SITE_ORIGIN,
      sameAs: SOCIAL_SAME_AS,
    },
    mainEntityOfPage: url,
  };
}

export function guidesIndexJsonLd(page, guides) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: page.h1,
    itemListElement: guides.map((guide, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: guide.h1,
      url: pageUrl(guide.path),
    })),
  };
}

export function servicesJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: SERVICES_PAGE.title,
    description: SERVICES_PAGE.description,
    url: pageUrl(SERVICES_PAGE.path),
    isPartOf: {
      '@type': 'WebSite',
      name: 'The WasteGame',
      url: SITE_ORIGIN,
    },
  };
}

export function webPageJsonLd(page) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: page.title,
    description: page.description,
    url: pageUrl(page.path),
  };
}
